module.exports = __webpack_public_path__ + "static/media/manager_star.f5a81232.svg";